import {
  PageDelimitationScaleContext,
  PageDelimiterContentHeightContext,
} from './page-delimitation-scale.context';

export const PageDelimitationScaleProvider = PageDelimitationScaleContext.Provider;
export const PageDelimiterContentHeightProvider = PageDelimiterContentHeightContext.Provider;
